module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "application-search-content-main"
  }, [_c('el-form', {
    staticClass: "application-search-content-main-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticClass: "application-search-content-main-fields-year"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "application-search-content-main-fields-year-items",
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('el-form-item', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'active' : '', 'application-search-content-main-fields-quarter']
    }, [_c('label', {
      on: {
        "click": function($event) {
          return _vm.handleMainSearch(quater)
        }
      }
    }, [_vm._v(_vm._s(quater))])])
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "application-search-content-main-roles",
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.selectRoleId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "selectRoleId", $$v)
      },
      expression: "searchMainData.selectRoleId"
    }
  }, _vm._l((_vm.userRoles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.roleName
      }
    })
  }), 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "application-search-content-main-fields-quarter-lines"
  }, _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('div', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'line-active' : '', 'application-search-content-main-fields-quarter-lines-line', 'application-search-content-main-fields-quarter-lines-line-q' + (index + 1)]
    })
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-main-tab"
  }, [_c('div', {
    staticClass: "main-blocks"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("预算使用进度"), _c('common-tooltip', {
    attrs: {
      "tipCode": '1.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['预算使用进度'].totalAmountStr))]), _vm._v(" "), _c('label', {
    class: ['main-block-contain-budget-percent', _vm.mainData['预算使用进度'].ratioNum > 120 ? 'main-block-contain-budget-percent-alert' : '']
  }, [_vm._v(_vm._s(_vm.mainData['预算使用进度'].ratio))]), _vm._v(" "), _c('label', {
    class: ['main-block-contain-budget-percent-title', _vm.mainData['预算使用进度'].ratioNum > 120 ? 'main-block-contain-budget-percent-alert' : '']
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "progress",
    style: ('width:' + (_vm.mainData['预算使用进度'].ratioNum > 100 ? '100%' : _vm.mainData['预算使用进度'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['4'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '2.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['4'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['4'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "pass",
    style: ('width:' + (_vm.mainData['4'].ratioNum > 100 ? '100%' : _vm.mainData['4'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['3'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '3.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['3'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['3'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "pending",
    style: ('width:' + (_vm.mainData['3'].ratioNum > 100 ? '100%' : _vm.mainData['3'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['5'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '4.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['5'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['5'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "reject",
    style: ('width:' + (_vm.mainData['5'].ratioNum > 100 ? '100%' : _vm.mainData['5'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].count))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "任务状态"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-content-fields-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAdvancedSearchClick()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "application-detail-info"
  }, [_vm._v("共计 " + _vm._s(_vm.applicationDetailCount) + " 场 预算总额：" + _vm._s(_vm._f("MoneyFormat")(_vm.applicationDetailAmt)) + " 当前排队审批中：" + _vm._s(_vm.inQueueNumber) + "场")]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-export"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.handlerExportExcelClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu"
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'productId': '*',
        'companyStrategy': '*',
        'strategyKeynote': '*',
        'medicalFieldResult': '*',
        'hospitalLevelId': '*',
        'speakerLevelId': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.applicationDetailData,
      "showEditFormTitle": false,
      "editDialogClass": "biz-application-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData
    },
    on: {
      "update:tableData": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingName",
      "label": "会议名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingSystem",
      "label": "系统选择",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingProp",
      "label": "会议性质",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingType",
      "label": "A1会议类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD项目类型",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD细类",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + scope.row.meetingGsdType, scope.row.meetingGsdSubType)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "totalAmount",
      "label": "会议总预算",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("MoneyFormat")(scope.row.totalAmount)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "queueTaskStatus",
      "label": "排队状态",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            'color': scope.row.queueTaskStatus == '失败' ? 'red' : '#2d82f0'
          })
        }, [_vm._v("                    \n                      " + _vm._s(scope.row.queueTaskStatus) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "width": "140"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("模型评分"), _c('common-tooltip', {
    attrs: {
      "tipCode": "7"
    }
  })], 1)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "meetingBeginDate",
      "label": "开始日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "cityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingWebStatus",
      "label": "会议计划状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCurrentOptName",
      "label": "会议计划审批结点",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "aoneExeStatus",
      "label": "会议执行状态",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "userRealName",
      "label": "会议组织者",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCode",
      "label": "计划编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventId",
      "label": "A1会议编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "label": "创建时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("DateHourMinutesFormat")(scope.row.createTime)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [(scope.row.meetingWebStatus == '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyClick(scope.row)
            }
          }
        }, [_vm._v("\n                      复制\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1) : _vm._e(), _vm._v(" "), (scope.row.meetingWebStatus != '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewClick(scope.row)
            }
          }
        }, [_vm._v("\n                      查看\n                    ")])], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("确认删除会议？")])])])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-info"
  }, [_vm._v("已选择 " + _vm._s(_vm.selectedData.length) + " 场会议 预算总额："), _c('label', [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.selectedTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit
    },
    on: {
      "click": _vm.handleApprovalRejectClick
    }
  }, [_vm._v("审批拒绝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit,
      "type": "primary"
    },
    on: {
      "click": _vm.handleApprovalConfirmClick
    }
  }, [_vm._v("审批通过")])], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticClass: "advanced-search-dialog",
    attrs: {
      "center": "",
      "visible": _vm.advancedSearchVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.advancedSearchVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "advancedSearchForm",
    attrs: {
      "model": _vm.searchData,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyizhuangtai'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议状态")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "任务状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议执行状态",
      "prop": "aoneExeStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.aoneExeStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "aoneExeStatus", $$v)
      },
      expression: "searchData.aoneExeStatus"
    }
  }, _vm._l((_vm.baseDataRecords.AoneExeStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "排队状态",
      "prop": "queueTaskStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.queueTaskStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "queueTaskStatus", $$v)
      },
      expression: "searchData.queueTaskStatus"
    }
  }, _vm._l((_vm.baseDataRecords.QueueTaskStatus.filter(function (q) { return q.value != '1'; })), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-jibinglingyu'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("疾病领域")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatmentArea", $$v)
      },
      expression: "searchData.treatmentArea"
    }
  }, _vm._l((_vm.baseDataRecords.TreatmentArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatmentAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "diseaseArea", $$v)
      },
      expression: "searchData.diseaseArea"
    }
  }, _vm._l((_vm.baseDataRecords.DiseaseArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.diseaseAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-chanpincelve'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("产品策略")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "companyStrategy", $$v)
      },
      expression: "searchData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "strategyKeynote", $$v)
      },
      expression: "searchData.strategyKeynote"
    }
  }, _vm._l((_vm.baseDataRecords.Strategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalFieldResult", $$v)
      },
      expression: "searchData.medicalFieldResult"
    }
  }, _vm._l((_vm.baseDataRecords.DomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatAreaResult
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-fugaiziyuan'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("覆盖资源")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医院层级",
      "prop": "hospitalLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevelId", $$v)
      },
      expression: "searchData.hospitalLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.HospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.offices),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "offices", $$v)
      },
      expression: "searchData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "讲者级别",
      "prop": "speakerLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.speakerLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevelId", $$v)
      },
      expression: "searchData.speakerLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.SpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-pingfenjieguo'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("评分结果")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "模型评分"
    }
  }, [_c('div', {
    staticClass: "advanced-search-dialog-score-model"
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "最小评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.minModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "minModelScore", $$v)
      },
      expression: "searchData.minModelScore"
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "placeholder": "最大评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.maxModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "maxModelScore", $$v)
      },
      expression: "searchData.maxModelScore"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyixinxi'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议信息")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "系统选择",
      "prop": "meetingSystem"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingSystem", $$v)
      },
      expression: "searchData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingProp", $$v)
      },
      expression: "searchData.meetingProp"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingProp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "是否网络会",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingModality", $$v)
      },
      expression: "searchData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingType", $$v)
      },
      expression: "searchData.meetingType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.searchData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdType", $$v)
      },
      expression: "searchData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdSubType", $$v)
      },
      expression: "searchData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingName", $$v)
      },
      expression: "searchData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划编号",
      "prop": "meetingCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCodeFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCodeData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingCode", $$v)
      },
      expression: "searchData.meetingCode"
    }
  }, _vm._l((_vm.remoteMeetingCodeData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1编号",
      "prop": "eventId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.eventId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "eventId", $$v)
      },
      expression: "searchData.eventId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议组织者",
      "prop": "userRealName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCreatorFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCreatorData = []
      }
    },
    model: {
      value: (_vm.searchData.userRealName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "userRealName", $$v)
      },
      expression: "searchData.userRealName"
    }
  }, _vm._l((_vm.remoteMeetingCreatorData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.CName,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingOrganizerId", $$v)
      },
      expression: "searchData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-shijian'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("时间地点")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "起止日期",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dateRange", $$v)
      },
      expression: "searchData.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.searchData.province),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "province", $$v)
      },
      expression: "searchData.province"
    }
  }, _vm._l((_vm.baseDataRecords.Province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    model: {
      value: (_vm.searchData.city),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "city", $$v)
      },
      expression: "searchData.city"
    }
  }, _vm._l((_vm.citiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "创建日期",
      "prop": "createDateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.createDateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createDateRange", $$v)
      },
      expression: "searchData.createDateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('label', {
    staticClass: "advanced-search-dialog-close",
    on: {
      "click": function($event) {
        _vm.advancedSearchVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3240deb5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3240deb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/meetingplan/task/index.vue
// module id = 1559
// module chunks = 7